import { PieChart } from "@mui/x-charts";
import { normalSanatizerBRL } from "src/utils/functions";

export function PrimeiroMilhaoPieChart({
  results,
}: {
  results: PrimeiroMilhaoResultsType;
}) {
  const pieData = [
    {
      id: 0,
      value: results.invested,
      label: "Valor Investido",
      color: "#6B7280", // Cinza padrão
    },
    {
      id: 1,
      value: results.interest,
      label: "Total em Juros",
      color: "#8D0202", // Vermelho padrão do site
    },
  ];

  const percentageInvested = (
    (results.invested / results.accumulated) *
    100
  ).toFixed(1);
  const percentageInterest = (
    (results.interest / results.accumulated) *
    100
  ).toFixed(1);

  return (
    <div className="w-full">
      {/* Container responsivo do gráfico */}
      <div className="w-full flex flex-col lg:flex-row items-center justify-center gap-6 bg-white border rounded p-4">
        {/* Gráfico de Pizza */}
        <div className="flex justify-center items-center min-h-[280px] w-full lg:w-auto">
          <PieChart
            series={[
              {
                data: pieData,
                highlightScope: { faded: "global", highlighted: "item" },
                faded: {
                  innerRadius: 30,
                  additionalRadius: -30,
                  color: "#E5E7EB",
                },
                valueFormatter: (item) =>
                  `R$ ${normalSanatizerBRL(item.value)}`,
                innerRadius: 40,
                outerRadius: 120,
                paddingAngle: 2,
                cornerRadius: 6,
              },
            ]}
            slotProps={{
              legend: {
                hidden: true,
              },
            }}
            width={280}
            height={280}
            margin={{ top: 20, bottom: 20, left: 20, right: 20 }}
          />
        </div>

        {/* Legenda personalizada e resumo */}
        <div className="flex flex-col gap-4 w-full lg:w-auto lg:max-w-sm">
          {/* Legenda personalizada */}
          <div className="space-y-3">
            <div className="flex items-center gap-4 p-3 bg-gray-50 rounded border">
              <div
                className="w-4 h-4 rounded-full flex-shrink-0"
                style={{ backgroundColor: "#6B7280" }}
              ></div>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-gray-700 block">
                  Valor Investido
                </span>
                <p className="font-bold text-lg text-gray-700">
                  R$ {normalSanatizerBRL(results.invested)}
                </p>
                <p className="text-xs text-gray-600">
                  {percentageInvested}% do total
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-3 bg-red-50 rounded border border-red-100">
              <div
                className="w-4 h-4 rounded-full flex-shrink-0"
                style={{ backgroundColor: "#8D0202" }}
              ></div>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-gray-700 block">
                  Total em Juros
                </span>
                <p className="font-bold text-lg" style={{ color: "#8D0202" }}>
                  R$ {normalSanatizerBRL(results.interest)}
                </p>
                <p className="text-xs text-gray-600">
                  {percentageInterest}% do total
                </p>
              </div>
            </div>
          </div>

          {/* Insight sobre juros compostos */}
          {results.interest > results.invested && (
            <div className="p-3 bg-green-50 border border-green-200 rounded">
              <div className="text-center">
                <p className="text-sm text-green-700 mb-2">
                  <strong>Poder dos Juros Compostos</strong>
                </p>
                <p className="text-2xl font-bold text-green-600">
                  {(
                    (results.interest / results.invested) *
                    100
                  ).toFixed(0)}
                  %
                </p>
                <p className="text-xs text-green-600">
                  mais em rendimentos do que investido
                </p>
              </div>
            </div>
          )}

          {/* Resumo do tempo */}
          <div className="p-3 bg-blue-50 border border-blue-200 rounded text-center">
            <p className="text-sm text-blue-700 mb-1">
              <strong>Tempo para a Meta</strong>
            </p>
            <p className="text-lg font-bold text-blue-600">
              {results.timeToGoal.years > 0 && `${results.timeToGoal.years} ano${results.timeToGoal.years !== 1 ? 's' : ''}`}
              {results.timeToGoal.years > 0 && results.timeToGoal.months > 0 && ' e '}
              {results.timeToGoal.months > 0 && `${results.timeToGoal.months} ${results.timeToGoal.months !== 1 ? 'meses' : 'mês'}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}